import { Controller } from "@hotwired/stimulus";

// Controller to toggle visibility of elements based on checkbox state.
// Usage:
//   <div data-controller="checkbox-visibility">
//     <input type="checkbox" data-checkbox-visibility-target="checkbox" data-action="change->checkbox-visibility#toggle">
//     <div data-checkbox-visibility-target="hiddenWhenChecked">Hidden when checked</div>
//     <div data-checkbox-visibility-target="shownWhenChecked">Shown when checked</div>
//   </div>
export default class extends Controller {
  static targets = ["checkbox", "hiddenWhenChecked", "shownWhenChecked"];

  connect() {
    this.toggle();
  }

  toggle() {
    const isChecked = this.checkboxTarget.checked;

    this.hiddenWhenCheckedTargets.forEach((el) => {
      el.classList.toggle("hidden", isChecked);
    });

    this.shownWhenCheckedTargets.forEach((el) => {
      el.classList.toggle("hidden", !isChecked);
    });
  }
}
